import { useState } from "react";
import Layout from "../../components/Layout";
import ChargeCodeComponent from "./VeterinerianChargeCodes";
import ChargeCodesPage from "./PetServiceChargeCodesPage";

import TaxCodeComponent from "./Taxcode";
import TaxCodesPage from "./PetServiceTaxCodepage";



const codeCategories = [
  { label: "Veterinarian Charges", value: "veterinarian" },
  { label: "Service Provider Charges", value: "service_provider" },
  // { label: "Service Provider Tax Codes", value: "service_provider_tax" },
  { label: "Tax Codes", value: "veterinarian_tax" },
];

export default function CodesPage() {
  const [selectedCategory, setSelectedCategory] = useState<string>("veterinarian");

  const renderCodes = () => {
    switch (selectedCategory) {
      case "service_provider":
        return <ChargeCodesPage />;
      case "veterinarian":
        return <ChargeCodeComponent />;
      // case "service_provider_tax":
      //   return <TaxCodesPage />;
      case "veterinarian_tax":
        return <TaxCodeComponent />;
      default:
        return <p>Select a category to view codes.</p>;
    }
  };

  return (
    <Layout>
      <div className="p-6">
        {/* Toggle Buttons */}
        <div className="flex gap-3 mb-6 flex-wrap">
          {codeCategories.map((cat) => (
            <button
              key={cat.value}
              onClick={() => setSelectedCategory(cat.value)}
              className={`px-4 py-2 rounded-lg border text-sm font-medium ${selectedCategory === cat.value
                ? "bg-black text-white"
                : "bg-white hover:bg-gray-100"
                }`}
            >
              {cat.label}
            </button>
          ))}
        </div>
        <div>{renderCodes()}</div>
      </div>
    </Layout>
  );
}
